"use client";

import { useEffect } from "react";
import { initDatadogRum } from "@utils/datadogRum";

export default function DatadogRumInitializer() {
  useEffect(() => {
    initDatadogRum();
  }, []);

  return null;
}
